/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  FeatureSetService,
} from '../../services/wealthlane-identity-services';
import { Wealthlane_AppServices_Features_DeleteFeatureSetResponseDto } from '../../services/wealthlane-identity-services/models/Wealthlane_AppServices_Features_DeleteFeatureSetResponseDto';

const useDeleteFeatureSet = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_AppServices_Features_DeleteFeatureSetResponseDto | undefined,
  unknown,
  string,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (id: string) => {
      return await handleRequest(
        FeatureSetService.deleteApiIdentityFeatureSet(id, true)
      );
    },
    {
      onSuccess: (response) => {
        if (response != null && response.success) {
          void queryClient.invalidateQueries('getVendorFeatureSet');
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={response.message ?? 'Feature Set deleted.'}
            />
          );
        }
      },
      onError: () => {
        closeModal();
      },
    }
  );
};

export default useDeleteFeatureSet;
